import { Project, DataFilter } from "interfaces";

import * as flowConfig from "./config";

export interface ProjectMetaData {
  [flowConfig.Y_COLUMN_KEY]: string;
  [flowConfig.TREATMENT_FILTERS_KEY]: DataFilter.Filter[];
  treatment_tag: string;
  control_tag: string;
}

export interface ImpactAnalysisContinousProject extends Project {
  flow: flowConfig.FLOW_TYPE;
  data_files: {
    [flowConfig.INPUT_DATA]: string;
  };
  meta_data: ProjectMetaData;
}

export const projectIsImpactAnalysisContinous = (
  project: Project
): project is ImpactAnalysisContinousProject =>
  project.flow === flowConfig.FLOW_NAME;
